<template>
<div>
    <HeadDetailsGama :titleHead="'Detalhe consulta de comissões'"></HeadDetailsGama>
    <div id="body-details" class="mt-4 ml-2">
                    <p class="ml-3 subtitle">  Forma de Pagamento: {{selectedComissao.proposta.formaPagamento}}</p>
                    <div class="d-flex flex-wrap">
                        <div class="col-md-4">
                            <p class="label-details">Valor Total do Imóvel</p>
                            <input class="input-details" v-model="selectedComissao.proposta.valorTotalFormatado"  disabled >
                        </div>
                        <div class="col-md-4 ">
                            <p class="label-details">Entrada 10%</p>
                            <input class="input-details"  disabled v-model="selectedComissao.proposta.valorEntradaFormatado">
                        </div>
                        <div class="col-md-4">
                            <p class="label-details">10% na Entrega Corrigindo pelo INCC</p>
                            <input disabled class="input-details" v-model="selectedComissao.proposta.valorEntregaFormatado" >
                        </div>
                        <div class="col-md-6 mt-3">
                            <p class="label-details">Parcelas Balões Anuais com Reajuste Mensal</p>
                            <input disabled class="input-details" v-model="selectedComissao.proposta.valorBalaoFormatado" >

                        </div>
                        <div class="col-md-6 mt-3">
                                <p class="label-details">Parcelas Mensais Consecutivas com Reajuste Mensal</p>
                                <input class="input-details" disabled  v-model="selectedComissao.proposta.valorMensalFormatado">
                            </div>

                    </div>

                    <p  class="ml-3 pt-4 subtitle">Empreendimento</p>
                    <div class="d-flex flex-wrap">
                    <div class="col-md-4">
                            <p class="label-details">Nome do Empreendimento</p>
                            <input class="input-details" v-model="selectedComissao.empreendimento.nome" disabled >
                    </div>
                    <div class="col-md-3 ">
                            <p class="label-details">Cidade</p>
                            <input class="input-details" v-model="selectedComissao.empreendimento.cidade.nome" disabled >
                    </div>
                    <div class="col-md-5">
                            <p class="label-details">Rua</p>
                            <input class="input-details" disabled v-model="selectedComissao.empreendimento.endereco">
                    </div>

                    <div class="col-md-2 mt-3">
                            <p class="label-details">Número</p>
                            <input class="input-details" disabled v-model="selectedComissao.empreendimento.numero">
                    </div>
                    <div class="col-md-4 mt-3">
                            <p class="label-details">Bairro</p>
                            <input class="input-details" disabled v-model="selectedComissao.empreendimento.bairro">
                    </div>
                    <div class="col-md-2 mt-3">
                            <p class="label-details">CEP</p>
                            <input class="input-details" disabled v-model="selectedComissao.empreendimento.cep">
                    </div>
                    <div class="col-md-2 mt-3">
                            <p class="label-details">Apartamento</p>
                            <input class="input-details" disabled v-model="selectedComissao.proposta.empreendimentoUnidade.unidade">
                    </div>
                  <div class="col-md-2 mt-3">
                            <p class="label-details">Torre</p>
                            <input class="input-details" disabled v-model="selectedComissao.proposta.empreendimentoUnidade.grupo">
                    </div>
            </div>
    </div>
    </div>
</template>
<script>
import Salesinformation from './salesinformation'
export default Salesinformation
</script>

<style scoped>

    .subtitle {
        font-size: 18px;
        color: #008148;
        font-weight: bold;
        margin-bottom: 15px;
    }

    .input-details{
        font-size: 13px;
        padding: 5px;
        width: 100%;
        height: 35px;
        border: 1px solid #D4D9DE;
        border-radius: 5px;
    }

    .head-container{
        display: flex;
        justify-content: space-between;
    }

    .label-details{
        margin-bottom: 0;
        font-size: 14px;
    }

    .form-control {
        background-color: #F1F1F1 !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/commissioncheck/components/salesinformation/salesinformation.vue